import UpdatePasswordForm from './UpdatePasswordForm'
export default UpdatePasswordForm
